const systemSet = () => import(/* webpackChunkName: "permissions" */ '../../views/systemSet'); // 系统设置
export default [
    {
        path: '/system',
        name: 'system',
        meta: { title: '系统设置',selfFlg: 'system', },

        component: systemSet
    }
];
